import { Component, OnInit } from '@angular/core';
import { PackageList, urlPath } from '../../shareModel';

@Component({
  standalone: false,
  selector: 'app-api-terms',
  templateUrl: './api-terms.component.html',
  styleUrls: ['./api-terms.component.css']
})
export class APITermsComponent implements OnInit {
  shareModel = {
    urlPath: urlPath
  };
  constructor() { }

  ngOnInit() {
  }

}
